import type { App } from 'vue'
import {
  Modal,
  Table,
  Menu,
  Input,
  Form,
  Card,
  Checkbox,
  Radio,
  Col,
  Row,
  Select,
  DatePicker,
  Tabs,
  Button,
  Divider,
  Pagination,
  Switch,
  Popconfirm,
  Tooltip,
  Layout,
  Descriptions,
  Breadcrumb,
  Dropdown,
  Avatar,
  Tag,
  Upload,
  Tree,
  Cascader,
  Timeline,
  Drawer,
  Empty,
  Progress,
  List,
  Spin,
  Popover,
  TreeSelect,
  Image,
  InputNumber,
  Result,
  Steps,
} from 'ant-design-vue'

export function setupAntd(app: App<Element>) {
  app.use(Modal)
  app.use(Table)
  app.use(Menu)
  app.use(Input)
  app.use(Form)
  app.use(Card)
  app.use(Checkbox)
  app.use(Radio)
  app.use(Col as any)
  app.use(Row as any)
  app.use(Select)
  app.use(DatePicker)
  app.use(Tabs)
  app.use(Button)
  app.use(Divider as any)
  app.use(Pagination as any)
  app.use(Switch as any)
  app.use(Popconfirm as any)
  app.use(Tooltip as any)
  app.use(Layout)
  app.use(Descriptions)
  app.use(Breadcrumb)
  app.use(Dropdown)
  app.use(Avatar)
  app.use(Tag)
  app.use(Upload)
  app.use(Tree)
  app.use(Cascader as any)
  app.use(Timeline)
  app.use(Drawer as any)
  app.use(Empty as any)
  app.use(Progress as any)
  app.use(List)
  app.use(Spin)
  app.use(Popover as any)
  app.use(TreeSelect)
  app.use(Image)
  app.use(InputNumber)
  app.use(Result)
  app.use(Steps)
  // app
  //   .use(Form)
  //   .use(Input)
  //   .use(Modal)
  //   .use(Table)
  //   .use(Menu)
  //   .use(Card)
  //   .use(Checkbox)
  //   .use(Radio)
  //   .use(Col)
  //   .use(Row)
  //   .use(Select)
  //   .use(DatePicker)
  //   .use(Tabs)
  //   .use(Button)
  //   .use(Divider)
  //   .use(Pagination)
  //   .use(Switch)
  //   .use(Popconfirm)
  //   .use(Tooltip)
  //   .use(Layout)
  //   .use(Descriptions)
  //   .use(Breadcrumb)
  //   .use(Dropdown)
  //   .use(Avatar)
  //   .use(Tag)
  //   .use(Upload)
  //   .use(Tree)
  //   .use(Cascader)
  //   .use(Timeline)
  //   .use(Drawer)
  //   .use(Empty)
  //   .use(Progress)
  //   .use(List)
  //   .use(Popover)
  //   .use(TreeSelect)
  //   .use(Image)
  //   .use(InputNumber)
  //   .use(Result)
  //   .use(Spin)
  //   .use(Steps)
}
